import type {HttpClient} from '@sollapay/http-client';
import type {ApiResponse, FeatureFlagsDTO} from '@sollapay/types';

export const featureFlagsApi = {
  fetchFeatureFlags: async (client: HttpClient, trustAccountId?: string) =>
    client.get<ApiResponse<FeatureFlagsDTO>>(
      trustAccountId ? `/trust_accounts/${trustAccountId}/feature-flags` : '/feature-flags'
    )
};
